import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { DashboardProvider } from "./DashboardContext";
import "./DashboardLayout.css";

const DashboardLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const location = useLocation();

    // Close sidebar on route change (Mobile only)
    useEffect(() => {
        setIsSidebarOpen(false);
    }, [location.pathname]);

    const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

    return (
        <DashboardProvider>
        <div className="dashboard-container">
            <div className={`dashboard-sidebar-wrapper ${isSidebarOpen ? "open" : ""} ${isCollapsed ? "collapsed" : ""}`}>
                <Sidebar
                    isOpen={isSidebarOpen}
                    toggleSidebar={toggleSidebar}
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setIsCollapsed}
                />
            </div>

            <div className="dashboard-navbar-wrapper">
                <Navbar
                    isSidebarOpen={isSidebarOpen}
                    toggleSidebar={toggleSidebar}
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setIsCollapsed}
                />
            </div>

            <main className="dashboard-main-content">
                <Outlet />
            </main>

            {/* Overlay for mobile when sidebar is open */}
            {isSidebarOpen && (
                <div
                    className="mobile-overlay d-lg-none"
                    onClick={toggleSidebar}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(57, 79, 101, 0.4)',
                        backdropFilter: 'blur(4px)',
                        zIndex: 105
                    }}
                />
            )}
        </div>
        </DashboardProvider>
    );
};

export default DashboardLayout;
